import SashiDo from 'lib/SashiDo';
import history from 'dashboard/history';
import React, { Component } from 'react';
import Modal from 'components/Modal/Modal.react';
import FormNote from 'components/FormNote/FormNote.react';
import Field from 'components/Field/Field.react';
import Label from 'components/Label/Label.react';
import TextInput from 'components/TextInput/TextInput.react';
import ChromeDropdown from 'components/ChromeDropdown/ChromeDropdown.react';
import AppsManager from 'lib/AppsManager';

const TICKET_TYPES = [
  { key: null, value: 'Please Select' },
  { key: 'migration', value: 'Migration' },
  { key: 'bug', value: 'Bug' },
  { key: 'billing', value: 'Billing' },
  { key: 'feature_request', value: 'Feature Request' },
  { key: 'feedback', value: 'Feedback' },
  { key: 'other', value: 'Other' },
];

export default class TeamDesk extends Component {
  constructor() {
    super();
    this.state = {
      isTeamDeskOpen: false,
      ticketType: null,
      apps: [{ key: null, value: 'Please Select' }],
      serviceName: null,
      sending: false,
      errorMessage: '',
    };

    this.handleKey = this.handleKey.bind(this);
  }

  componentDidMount() {
    this.justListen();

    const apps = AppsManager.apps();

    apps.forEach((app) => {
      this.state.apps.push({ key: app.serviceName, value: app.name });
    });

    this.state.apps.push({ key: '-NOT APP RELATED-', value: 'Not related to any application' });

    document.body.addEventListener('keydown', this.handleKey);
  }

  componentWillUnmount() {
    document.body.removeEventListener('keydown', this.handleKey);
  }

  handleKey(e) {
    var keyCode = e.keyCode || e.which;
    switch (keyCode) {
      case 27:
        this.handleTeamDeskClose();

        break;
    }
  }

  justListen() {
    history.listen(({
      state: currentHistoryState
    }) => {
      const { isTeamDeskOpen, ...rest } = currentHistoryState || {};

      if (isTeamDeskOpen) {
        this.setState({
          isTeamDeskOpen: true,
          ...rest,
        });
      }
    });
  }

  handleTeamDeskClose = () => {
    if (this.state.isTeamDeskOpen) {
      this.setState({
        ticketType: '',
        serviceName: '',
        subject: '',
        message: '',
        errorMessage: '',
        sending: false,
        isTeamDeskOpen: false,
      });
    }
  }

  handleTeamDeskSubmit = () => {
    const appInfo = this.state.apps.find(app => app.key === this.state.serviceName);

    const message = (
      this.state.stepsToReproduce
        ?
        `${this.state.message.replace(/(?:\r\n|\r|\n)/g, '<br />')}<br /><br /><br />` + '========== Steps to reproduce ==========' + `<br /><br />${this.state.stepsToReproduce}`
        :
        this.state.message.replace(/(?:\r\n|\r|\n)/g, '<br />')
    );

    const params = {
      ticketType: this.state.ticketType,
      appName: appInfo.value,
      subject: this.state.subject,
      message,
      serviceName: appInfo.key,
    };

    this.setState({ sending: true });

    return SashiDo.sentTeamworkTicket(params).then(() => {
      this.handleTeamDeskClose();
    }, () => {
      this.setState({
        sending: false,
        errorMessage: 'There seems to be a problem sending the ticket. Please try again if the problem persists you can open a ticket by sending an email to support@sashido.io',
      });
    });
  }

  validation() {
    if (this.state.ticketType === 'bug') {
      return !(this.state.ticketType && this.state.serviceName && this.state.subject && this.state.message && this.state.stepsToReproduce);
    }
    return !(this.state.ticketType && this.state.serviceName && this.state.subject && this.state.message);
  }

  render() {
    const appInfo = this.state.apps.find(app => app.key === this.state.serviceName);
    const modal = (
      this.state.isTeamDeskOpen
        ?
        (
          <Modal
            title="Open a Ticket"
            subtitle="We will answer you within 24 hours."
            confirmText={(!this.state.sending && this.state.errorMessage.length > 0) ? 'Try Again' : 'Submit'}
            disabled={this.validation()}
            cancelText="Cancel"
            footerDetails="* Required Field"
            progress={this.state.sending}
            onCancel={this.handleTeamDeskClose}
            onConfirm={this.handleTeamDeskSubmit}>

            <Field
              label={<Label text="* Type of the ticket?" />}
              input={
                <ChromeDropdown
                  value={this.state.ticketType}
                  options={TICKET_TYPES}
                  placeholder={(this.state.ticketType && this.state.ticketType !== "") ? TICKET_TYPES.find(f => f.key === this.state.ticketType).value : "Please Select"}
                  onChange={ticketType => this.setState({ ticketType })} />
              } />

            <Field
              label={<Label text="* This ticket is related with application called?" />}
              input={
                <ChromeDropdown
                  value={appInfo.value}
                  options={this.state.apps}
                  placeholder="Please Select"
                  placeholder={(appInfo.value && appInfo.value !== "") ? appInfo.value : "Please Select"}
                  onChange={serviceName => this.setState({ serviceName })} />
              } />

            <Field
              label={<Label text="* Subject" />}
              input={<TextInput placeholder="Your subject ..." value={this.state.subject} onChange={(subject) => { this.setState({ subject }); }} />
              } />

            <Field
              label={<Label text="* Message" />}
              input={<TextInput placeholder="Your message ..." value={this.state.message} height={120} multiline onChange={(message) => { this.setState({ message }); }} />
              } />

            {
              this.state.ticketType === 'bug'
                ?
                <Field
                  label={<Label text="* Steps to reproduce" />}
                  input={
                    <TextInput
                      placeholder="Please include important info that will help our engineers to re-create the issue faster. You may include links to screenshots, copy error messages, share with us the exact order of actions you have taken before the error appeared, etc- whichever you think is important and will help us minimize the ticket handling time."
                      value={this.state.stepsToReproduce}
                      height={120}
                      multiline
                      onChange={(stepsToReproduce) => { this.setState({ stepsToReproduce }); }} />
                  } />
                :
                null
            }


            {
              !this.state.sending
                ?
                <FormNote
                  show={this.state.errorMessage.length > 0}
                  color="red" >
                  {this.state.errorMessage}
                </FormNote>
                : null
            }
          </Modal>
        )
        : null
    );

    return modal;
  }
}
